import DefaultApiService from "./default";

const unwrap = (res) => res?.data ?? res?.Data ?? null;

const LoanGuarantorApi = {
  get: async (apiBase, requestInfoId) => {
    const res = await DefaultApiService.getApi(`${apiBase}/GetLoanGuarantor`, {
      requestInfoId,
    });
    return unwrap(res);
  },

  save: async (apiBase, payload) => {
    const res = await DefaultApiService.postApi(
      `${apiBase}/SaveLoanGuarantor`,
      payload
    );
    return res;
  },

  retryCreditInquiry: async (apiBase, requestInfoId) => {
    const res = await DefaultApiService.postApi(
      `${apiBase}/RetryGuarantorCreditInquiry?requestInfoId=${Number(requestInfoId)}`,
      {}
    );
    return res;
  },
};

export default LoanGuarantorApi;
